//
import Endereco from '../../shared/entity/Endereco';
import { cepMask } from '../../shared/helper';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { Alert, StyleSheet } from 'react-native';
import Collapsible from 'react-native-collapsible';
import { ActivityIndicator } from 'react-native-paper';
import { StackParamList } from '../../../App';
import cepApi from '../../apis/cepApi';
import clienteApi from '../../apis/clienteApi';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING } from '../../constants';
import { useAlert } from '../../redux/alert/alertHooks';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import { usePedido } from '../../redux/pedido/pedidoHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Button from '../Generic/Button';
import CTextInput from '../Generic/CTextInput';
import Form from '../Generic/Form';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import Title from '../Generic/Title';

type Props = {
  navigation: StackNavigationProp<StackParamList, 'NovoEnderecoPage'>;
  route: RouteProp<StackParamList, 'NovoEnderecoPage'>;
};

const NovoEnderecoPage: React.FC<Props> = (props) => {
  const { navigation, route } = props;
  const { refresh } = route.params;

  const [pedido] = usePedido();

  const [empresa] = useEmpresa();
  const [endereco, setEndereco] = useState(new Endereco());
  const [carregandoCep, setCarregandoCep] = useState(false);

  const [consulteiCep, setConsulteiCep] = useState(false);
  const [travarLogradouro, setTravarLogradouro] = useState(false);
  const [travarBairro, setTravarBairro] = useState(false);
  const [travarComplemento, setTravarComplemento] = useState(false);
  const [travarCidade, setTravarCidade] = useState(false);
  const [mostrarAlert] = useAlert();

  useEffect(() => {
    if (endereco.cep.length === 9) {
      consultarCep();
    } else {
      if (consulteiCep) {
        limparCep();
      }
    }
  }, [endereco.cep]);

  const salvar = async () => {
    try {
      if (!consulteiCep && !empresa.aceitaEnderecoSemCEP) {
        mostrarAlert('Erro', 'Preencha um Cep válido.');
        return;
      }
      if (endereco.apelido === '') {
        endereco.apelido = 'Padrão';
      }
      if (endereco.cep === '' && !empresa.aceitaEnderecoSemCEP) {
        mostrarAlert('Erro', 'Preencha o campo cep');
        return;
      }
      if (endereco.bairro === '') {
        mostrarAlert('Erro', 'Preencha o campo bairro');
        return;
      }
      if (endereco.logradouro === '') {
        mostrarAlert('Erro', 'Preencha o campo logradouro');
        return;
      }
      if (endereco.numero === '') {
        mostrarAlert('Erro', 'Preencha o campo número');
        return;
      }
      await clienteApi.novoEndereco(endereco, pedido.clienteId);

      await refresh();
      // if (sessao.cliente.nivel > 0) {
      //   const cliente = await getCliente(pedido.clienteId);
      //   setPedido({ ...pedido, cliente, clienteId: cliente.id });
      // } else {
      //   await revalidate();
      // }

      navigation.goBack();
    } catch (err) {
      console.log('err', err);
      mostrarAlert('Erro.', `Ocorreu um erro ao finalizar o registro: ${err.data || err.message}`);
    }
  };

  const consultarCep = async () => {
    try {
      setCarregandoCep(true);
      const cep = await cepApi.getCep(endereco.cep);
      console.log('Cep', cep);
      if (!cep) {
        throw '';
      }
      if (cep.localidade !== 'Formiga') {
        mostrarAlert('Erro', 'Fazemos entrega apenas em Formiga - MG.');
        return;
      }

      setConsulteiCep(true);
      endereco.logradouro = cep.logradouro;
      setTravarLogradouro(cep.logradouro !== '');
      endereco.bairro = cep.bairro;
      setTravarBairro(cep.bairro !== '');
      endereco.complemento = cep.complemento;
      setTravarComplemento(cep.complemento !== '');
      endereco.cidade = cep.localidade;
      setTravarCidade(true);
      setEndereco({ ...endereco });
      setCarregandoCep(false);
    } catch (err) {
      setCarregandoCep(false);
      mostrarAlert('Erro', 'Cep não encontrado.');
    }
  };

  const limparCep = async () => {
    setConsulteiCep(false);
    endereco.logradouro = '';
    endereco.bairro = '';
    endereco.complemento = '';
    endereco.cidade = '';
    setTravarLogradouro(false);
    setTravarBairro(false);
    setTravarComplemento(false);
    setTravarCidade(false);
    setCarregandoCep(false);
    setEndereco({ ...endereco });
  };

  return (
    <PageContainer header={<Header goBack />}>
      <Title style={{ marginBottom: 20, alignSelf: 'center' }}>Novo Endereço</Title>
      <Form>
        <CTextInput
          label={'Apelido do endereço'}
          placeholder={"Ex: 'Casa'"}
          onChangeText={(txt) => {
            const newEndereco = { ...endereco };
            newEndereco.apelido = txt;
            setEndereco(newEndereco);
          }}
          value={endereco.apelido}
          style={styles.input}
        />

        <CTextInput
          label={'Cep'}
          maxLength={9}
          onChangeText={(txt) => {
            txt = cepMask(txt);
            const newEndereco = { ...endereco };
            newEndereco.cep = txt;
            setEndereco(newEndereco);
          }}
          value={endereco.cep}
          style={styles.input}
        />

        {carregandoCep && (
          <Collapsible collapsed={!carregandoCep}>
            <ActivityIndicator size={40} color={colors.primary} style={{ marginBottom: 15 }} />
          </Collapsible>
        )}

        <Collapsible collapsed={!consulteiCep && !empresa.aceitaEnderecoSemCEP}>
          <CTextInput
            label={'Cidade*'}
            placeholder={"Ex: 'Rua dos viajantes'"}
            onChangeText={(txt) => {
              const newEndereco = { ...endereco };
              newEndereco.cidade = txt;
              setEndereco(newEndereco);
            }}
            value={endereco.cidade}
            style={[
              styles.input,
              travarCidade ? { backgroundColor: 'rgba(76,175,80,0.15)' } : undefined
            ]}
            disabled={(!consulteiCep && !empresa.aceitaEnderecoSemCEP) || travarCidade}
          />

          <CTextInput
            label={'Logradouro*'}
            placeholder={"Ex: 'Rua dos viajantes'"}
            onChangeText={(txt) => {
              const newEndereco = { ...endereco };
              newEndereco.logradouro = txt;
              setEndereco(newEndereco);
            }}
            value={endereco.logradouro}
            style={[
              styles.input,
              travarLogradouro ? { backgroundColor: 'rgba(76,175,80,0.15)' } : undefined
            ]}
            disabled={(!consulteiCep && !empresa.aceitaEnderecoSemCEP) || travarLogradouro}
          />

          <CTextInput
            label={'Complemento'}
            placeholder={"Ex: 'AP 201'"}
            onChangeText={(txt) => {
              const newEndereco = { ...endereco };
              newEndereco.complemento = txt;
              setEndereco(newEndereco);
            }}
            value={endereco.complemento}
            style={[
              styles.input,
              travarComplemento ? { backgroundColor: 'rgba(76,175,80,0.15)' } : undefined
            ]}
            disabled={(!consulteiCep && !empresa.aceitaEnderecoSemCEP) || travarComplemento}
          />

          <CTextInput
            label={'Bairro*'}
            onChangeText={(txt) => {
              const newEndereco = { ...endereco };
              newEndereco.bairro = txt;
              setEndereco(newEndereco);
            }}
            value={endereco.bairro}
            style={[
              styles.input,
              travarBairro ? { backgroundColor: 'rgba(76,175,80,0.15)' } : undefined
            ]}
            disabled={(!consulteiCep && !empresa.aceitaEnderecoSemCEP) || travarBairro}
          />

          <CTextInput
            label={'Número*'}
            onChangeText={(txt) => {
              const newEndereco = { ...endereco };
              newEndereco.numero = txt;
              setEndereco(newEndereco);
            }}
            value={endereco.numero}
            style={styles.input}
            disabled={!consulteiCep && !empresa.aceitaEnderecoSemCEP}
          />

          <CTextInput
            label={'Referência'}
            onChangeText={(txt) => {
              const newEndereco = { ...endereco };
              newEndereco.referencia = txt;
              setEndereco(newEndereco);
            }}
            value={endereco.referencia}
            style={styles.input}
            disabled={!consulteiCep && !empresa.aceitaEnderecoSemCEP}
          />
        </Collapsible>
        <Button title={'Salvar'} onPress={salvar} />
      </Form>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff'
  },
  content: {
    paddingTop: TOP_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  form: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default NovoEnderecoPage;
